module.exports = __webpack_public_path__ + "public/images/slider/ferdman-circle.8033961acfa19360b9d1842b180fd8f3.webp";